import { render, staticRenderFns } from "./MatchRuleEdit.vue?vue&type=template&id=483555e5&"
import script from "./MatchRuleEdit.vue?vue&type=script&lang=js&"
export * from "./MatchRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports